import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { INTRO_VIDEO } from "./IntroVideoModal";

interface IntroVideoCardProps {
  onPlay: () => void;
  className?: string;
}

const IntroVideoCard: React.FC<IntroVideoCardProps> = ({ onPlay, className = "" }) => {
  return (
    <button
      type="button"
      onClick={onPlay}
      aria-label="Play Don's 52-second introduction video"
      className={`group relative block w-full aspect-video p-0 rounded-2xl overflow-hidden border border-cyan-400/40 bg-slate-950 shadow-[0_0_40px_8px_rgba(55,216,184,0.25)] hover:border-cyan-300/70 hover:shadow-[0_0_50px_12px_rgba(55,216,184,0.35)] transition-[border-color,box-shadow] duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400 ${className}`}
    >
      <img
        src={INTRO_VIDEO.poster}
        alt=""
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <span
        className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/20 to-transparent"
        aria-hidden="true"
      />

      <span
        className="absolute inset-0 flex items-center justify-center"
        aria-hidden="true"
      >
        <span className="relative flex h-16 w-16 items-center justify-center">
          <span className="absolute inline-flex h-full w-full rounded-full bg-cyan-400/50 animate-ping" />
          <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-cyan-500 text-slate-950 shadow-lg shadow-cyan-500/40 group-hover:bg-cyan-400 group-hover:scale-110 transition-all duration-300">
            <FontAwesomeIcon icon={faPlay} className="text-xl ml-1" />
          </span>
        </span>
      </span>

      <span
        className="absolute top-3 right-3 rounded-full bg-slate-950/80 px-2.5 py-1 font-mono text-xs text-white/90 border border-white/10"
        aria-hidden="true"
      >
        {INTRO_VIDEO.duration}
      </span>

      <span
        className="absolute bottom-3 left-4 right-4 flex flex-col items-start text-left"
        aria-hidden="true"
      >
        <span className="font-mono text-xs md:text-sm tracking-widest uppercase text-cyan-400">
          Meet Don
        </span>
        <span className="text-sm md:text-base font-semibold text-white">
          Who I am and how I work
        </span>
      </span>
    </button>
  );
};

export default IntroVideoCard;
